import React from "react"
import PropTypes from "prop-types"
import { formatElapsedTimeNumbers } from "../utils/useGameClock"
import { getMessages } from "../utils/translations"

function Finish(props) {
  const { bg, stop, start, elapsedTime, language } = props
  const messages = getMessages(language)

  return (
    <div className={"finish " + bg}>
      <strong>{messages.timeLabel}</strong>
      <p className="time">{formatElapsedTimeNumbers(elapsedTime)}</p>
      {/* {errors > 0 && <p>Du lagst nur <strong>{errors}</strong> mal daneben!</p>} */}
      <nav>
        <button onClick={start}>{messages.restart}</button>
        <button onClick={stop}>{messages.quit}</button>
      </nav>
    </div>
  )
}

Finish.propTypes = {
  bg: PropTypes.string.isRequired,
  start: PropTypes.func.isRequired,
  stop: PropTypes.func.isRequired,
  finish: PropTypes.func.isRequired,
  errors: PropTypes.number,
  elapsedTime: PropTypes.number.isRequired,
  language: PropTypes.string,
}

export default Finish
